import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { useWocommercePriceUIContext } from "./WocommercePriceUIContext";
import { WocommercePriceTable } from "./wocommerce-price-table/WocommercePriceTable";

export default function WocommercePriceCard() {
  
  const priceUIContext = useWocommercePriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      newPriceButtonClick: priceUIContext.newPriceButtonClick,
    };
  }, [priceUIContext]);

  return (
    <Card>
      <CardHeader title='Wocommerce Pricing'>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={priceUIProps.newPriceButtonClick}>
            <i className="fas fa-plus-circle"></i> Add New Wocommerce Price
          </button>
        </CardHeaderToolbar>
      </CardHeader>{" "}  
      <CardBody>

        <WocommercePriceTable />
      </CardBody>
    </Card>
  );
}
